import { showElem, stopElemAnim, addCloseElemAnim, hideElem } from './utils';
import { timeout } from './utils';

const showSubmenu = (elem, overlay) => {
  stopElemAnim(elem);
  stopElemAnim(overlay);

  showElem(elem);
  showElem(overlay);
};

const hideSubmenu = (elem, overlay, target) => {
  addCloseElemAnim(overlay);
  hideElem(elem);

  timeout.id = setTimeout(() => {
    if (
      !target ||
      (!target.classList.contains('nav-submenu-item__link') &&
        !target.classList.contains('header__bottom'))
    ) {
      hideElem(overlay);
    }
  }, 300);
};

export const initSubmenu = () => {
  const overlayTop = document.querySelector('.overlay-top');
  const overlayBottom = document.querySelector('.overlay-bottom');
  const submenuItems = document.querySelectorAll('.nav-submenu-item');

  submenuItems.forEach((submenuItem) => {
    const submenu = submenuItem.querySelector('.submenu');

    submenuItem.addEventListener('mouseenter', (e) => {
      clearTimeout(timeout.id);

      if (e.target.closest('.header__top')) {
        showSubmenu(submenu, overlayTop);
      }

      if (e.target.closest('.header__bottom')) {
        showSubmenu(submenu, overlayBottom);
      }
    });
    submenuItem.addEventListener('mouseleave', (e) => {
      if (e.target.closest('.header__top')) {
        hideSubmenu(submenu, overlayTop, e.relatedTarget);
      }

      if (e.target.closest('.header__bottom')) {
        hideSubmenu(submenu, overlayBottom, e.relatedTarget);
      }
    });

    submenuItem.addEventListener('keydown', (e) => {
      const submenuBtn = e.currentTarget.querySelector('button');
      const keyCode = e.code;

      if (keyCode === 'Space' || keyCode === 'Enter') {
        clearTimeout(timeout.id);
        if (submenuBtn.getAttribute('aria-expanded') === 'true') {
          if (e.target.closest('.header__top')) {
            hideSubmenu(submenu, overlayTop, e.relatedTarget);
          }

          if (e.target.closest('.header__bottom')) {
            hideSubmenu(submenu, overlayBottom, e.relatedTarget);
          }

          submenuBtn.setAttribute('aria-expanded', 'false');
        } else {
          if (e.target.closest('.header__top')) {
            showSubmenu(submenu, overlayTop);
          }

          if (e.target.closest('.header__bottom')) {
            showSubmenu(submenu, overlayBottom);
          }

          submenuBtn.setAttribute('aria-expanded', 'true');
        }
      }
    });

    submenuItem.addEventListener('focusout', (e) => {
      const currentTargetLastClass = '.' + e.currentTarget.classList[1];
      const submenuBtn = e.currentTarget.querySelector('button');

      if (!e.relatedTarget.closest(currentTargetLastClass)) {
        if (e.target.closest('.header__top')) {
          hideSubmenu(submenu, overlayTop, e.relatedTarget);
        }

        if (e.target.closest('.header__bottom')) {
          hideSubmenu(submenu, overlayBottom, e.relatedTarget);
        }

        submenuBtn.setAttribute('aria-expanded', 'false');
      }
    });
  });
};
